const Footer = () => {
  return (
    <div className="bg-violet-900 mt-16 py-10 px-20 flex justify-between text-white text-[15px]">
      <div>
        © 2026 Copyright 2026. All rights reserved
      </div>

      <div className="flex gap-10 items-center">
        <a href="https://clusterview.ai/contact" target="_blank" rel="noopener noreferrer">Contact Us</a>
        <a href="https://clusterview.ai/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        <a href="https://clusterview.ai/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      </div>
    </div>
  )
}

export default Footer;